import React, { useEffect, useState } from 'react'
import { FiUpload } from 'react-icons/fi'
import { FaCloudUploadAlt, FaRegCalendarAlt, FaSpinner } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { onKycInputFieldAction, onKycOtpVerifyAction, onKycPanNumberAction, onKycRejectQuery, onKycUpdate } from '../../../Redux/Actions/AuthActions';
import { setAlert } from '../../../Redux/Actions/AlertActions';
import AadharFront from "../../../images/aadhar-card-front.png"
import AadharBack from "../../../images/aadhar-back-img.png"
import Pancard from "../../../images/pan-card-img.webp"
import { HiOutlineBellAlert } from 'react-icons/hi2';
import { Alert } from "react-bootstrap";
import KycModel from './KycModel';
import { IoAlertCircleOutline } from "react-icons/io5";
import CommonInputFieldKycModel from '../../Common/CommonInputFieldKycModel';
import ConfirmModelOtp from '../../Common/ConfirmModelOtp';
import { Calendar } from 'primereact/calendar';
// import { FaRegCalendarAlt } from "react-icons/fa";
const TaskerKyc = () => {
    const dispatch = useDispatch()
    const e_aadhar_kyc = useSelector(state => state.auth.user.e_aadhar_kyc)
    const e_pan_kyc = useSelector(state => state.auth.user.e_pan_kyc)
    const user = useSelector(state => state.auth.user)

    const kyc = useSelector(state => state.auth.user.kyc)

    const kycVerified = useSelector(state => state.auth.user.is_kyc_verified)
    const kycVerifiedAgency = useSelector(state => state.auth.user.is_kyc_agency_verified)
    const [showKyc, setShowKyc] = useState(false)
    const handleClose = () => setShowKyc(false)
    const [show, setShow] = useState(true);
    const [inputAadhar, setInputAadhar] = useState("")
    const [otp, setOtp] = useState("")
    const [referenceId, setReferenceId] = useState("")
    const [kycId, setKycId] = useState("")
    const [pan_ocr, setPan_ocr] = useState({
        "Pan": "",
        "dateOfBirth": "",
        "name": ""
    })
    const [show1, setShow1] = useState(true)
    const handleClose1 = () => setShow1(false)
    const handleShow1 = () => setShow1(true)
    const [show2, setShow2] = useState(false)
    const handleClose2 = () => setShow2(false)
    const handleShow2 = () => setShow2(true)

    const [text, setText] = useState("")
    const [loader, setLoader] = useState({
        fetch: false,
        update: false,
        submit: false,
        input: false,
        otp: false,
        pan: false
    })
    const [aadhar_card_frontUrl, setAadhar_card_frontUrl] = useState(null);
    const [aadhar_card_backUrl, setAadhar_card_backUrl] = useState(null);
    const [pan_cardUrl, setPan_cardUrl] = useState(null);
    const [selectType, setSelectType] = useState('')
    const [disabled, setDisabled] = useState(false)
    // const [date, setDate] = useState(null)




    const onCompleted = (url, type) => {
        if (type === "pan_card") {
            setPan_cardUrl(url)
        } else if (type === "aadhar_card_front") {
            setAadhar_card_frontUrl(url)
        } else {
            setAadhar_card_backUrl(url)
        }
    }
    const handleFileChange = (file, type) => {
        setSelectType(type)
        if (file?.size > 200 * 1024 * 1024) {

            dispatch(setAlert("File size exceeds 200MB. Please upload a smaller file.", "danger"));
            return;
        }
        if (file) {
            setLoader({
                ...loader,
                update: true
            })
            const objectURL = URL.createObjectURL(file);
            if (type === "pan_card") {
                setPan_cardUrl(objectURL)
            } else if (type === "aadhar_card_front") {
                setAadhar_card_frontUrl(objectURL)
            } else {
                setAadhar_card_backUrl(objectURL)
            }
            const formData = new FormData();
            formData.append(`type`, type)
            formData.append(`image`, file);
            dispatch(onKycUpdate(formData, loader, setLoader, setDisabled))

        }
    };
    const handleDrop = (e, type) => {
        e.preventDefault();
        const files = e.dataTransfer.files[0];

        handleFileChange(files, type)

    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };
    const isUploadDisabled = kycVerified === "1" || kyc?.is_verified === "2"
    const isUploadDisabledPen = user?.e_pan_kyc === "1"


    useEffect(() => {
        if (!kyc) return;

        const {
            aadhar_card_front,
            aadhar_card_back,
            pan_card,
            id,
            front_number,
            back_number,
            pan_ocr
        } = kyc;

        setAadhar_card_frontUrl(aadhar_card_front || null);
        setAadhar_card_backUrl(aadhar_card_back || null);
        setPan_cardUrl(pan_card || null);
        setKycId(id || "");
        setInputAadhar(front_number?.replace(/\s/g, "") || back_number?.replace(/\s/g, "") || "");

        if (pan_ocr) {
            try {
                const parsed = JSON.parse(pan_ocr);
                const ocrData = parsed?.data?.data;
                if (ocrData) {
                    setPan_ocr({
                        Pan: ocrData.Pan || "",
                        dateOfBirth: ocrData.dateOfBirth || "",
                        name: ocrData.name || ""
                    });
                }
            } catch (error) {
                console.error("Invalid JSON in kyc.pan_ocr:", error);
            }
        }
    }, [kyc]);

    const handleQuerySubmit = (e) => {
        e.preventDefault();
        if (text === "") {
            dispatch(setAlert("Please enter comment", "danger"));
            return;
        }

        setLoader({
            ...loader,
            submit: true
        })
        let formData = {
            "comment": text,
            "id": kyc?.id
        }
        dispatch(onKycRejectQuery(formData, loader, setLoader, handleClose))
    }
    const handleChangeOcr = (e) => {
        const { name, value } = e.target;

        if (name === null) {

            const date = value.toLocaleDateString('en-CA')

            setPan_ocr({ ...pan_ocr, "dateOfBirth": date })
        } else {
            setPan_ocr({ ...pan_ocr, [name]: value })
        }
        // setPan_ocr({ ...pan_ocr, [name]: value })
    }
    const handleSubmitPanVerify = (e) => {
        e.preventDefault()
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (pan_ocr?.Pan) {
            const panNumber = pan_ocr.Pan.trim().toUpperCase();

            if (!panRegex.test(panNumber)) {
                dispatch(setAlert("Invalid PAN card format. Example: ASDFG6323E", "danger"));
                return;
            }
        }
        setLoader({
            ...loader,
            pan: true
        })
        let formData = {
            "kyc_id": kycId,
            "pan": pan_ocr.Pan,
            "dob": pan_ocr?.dateOfBirth,
            "name": pan_ocr.name
        }

        dispatch(onKycPanNumberAction(formData, loader, setLoader))
    }
    const handleInputFieldSubmit = (e) => {
        e.preventDefault()
        if (inputAadhar) {
            const sanitizedAadhar = inputAadhar.trim();
            const aadharRegex = /^\d{12}$/;
            if (!aadharRegex.test(sanitizedAadhar)) {
                dispatch(setAlert("Aadhaar must be exactly 12 digits", "danger"));
                return;
            }
            setLoader({
                ...loader,
                input: true
            })

            let formData = {
                "aadhar": inputAadhar,
                "kyc_id": kycId,
            }
            dispatch(onKycInputFieldAction(formData, loader, setLoader, handleShow2, setReferenceId))
        }
    }
    const handleOtpFieldSubmit = () => {
        setLoader({
            ...loader,
            otp: true
        })
        if (otp.length < 6) {

            setLoader({
                ...loader,
                otp: false
            })
            dispatch(setAlert("Please enter OTP", "danger"))
            return;
        }
        let formData = {
            otp: otp,
            "kyc_id": kycId,
            "reference_id": referenceId
        }
        dispatch(onKycOtpVerifyAction(formData, loader, setLoader, handleClose2))
    }

    return (
        <div className='creater-new-task'>
            <div className='account-block mb-5 ps-4 pb-0'>
                <div className='d-flex gap-2 '>
                    {kyc && Object.keys(kyc).length > 0 ? <p> Your KYC verfication status is</p> : ""}

                    <p>{kyc?.is_verified === "2" ? <span className="verBadge" style={{ backgroundColor: "#DEF8EE", color: "#4AA785", padding: "5px 10px", borderRadius: "50px" }}> Verified</span> : kyc?.is_verified === "1" ? <span className="verBadge" style={{ backgroundColor: "rgb(255, 243, 205)", color: "rgb(133, 100, 4)", padding: "5px 10px", borderRadius: "50px" }}>Pending</span> : kyc?.is_verified === "3" ? <span className="verBadge" style={{ backgroundColor: "#f8d7da", color: " #721c24", padding: "5px 10px", borderRadius: "50px" }}>Rejected</span> : ""} </p>

                </div>

                {kyc.is_verified === "3" && show === true ?
                    <div>
                        <Alert
                            className="theme-alert"
                            style={{ backgroundColor: "#f8d7da", borderLeft: "6px solid #721c24" }}
                        // onClose={() => handleAlertClose(i)}
                        // dismissible
                        >
                            <div className="d-flex w-100 align-items-start align-items-md-center flex-column flex-md-row">
                                <div className="col-auto ps-2 pe-0">
                                    <IoAlertCircleOutline
                                        style={{ fontSize: "25px", color: "#721c24" }} />
                                </div>
                                <div className="col-auto ps-2 ps-lg-1">
                                    <p style={{ color: "#721c24" }}>Your kyc document is not verified due to {kyc?.reason} </p>
                                </div>
                                <div className='ms-auto'>
                                    <button class="theme-btn" type="button" onClick={() => setShowKyc(true)} >Message</button>
                                </div>
                            </div>
                        </Alert>
                    </div>
                    : ""}
                <div className="submission_wrap submission_bg pt-4 pb-0">

                    <div className="row align-items-center  mb-2 mb-md-5">
                        <div className="col-xl-6 col-xxl-6 col-lg-6 col-sm-12 col-md-5 mb-4">
                            <h3 className='mb-3' style={{ fontSize: "18px" }}>Pan card</h3>
                            <div className=" create_upload mt-3 mb-3 mb-lg-4"
                                onDragOver={(e) => !isUploadDisabledPen && handleDragOver(e)}
                                onDrop={(e) => !isUploadDisabledPen && handleDrop(e, "pan_card")}
                                style={{ cursor: isUploadDisabledPen ? "not-allowed" : "pointer", opacity: isUploadDisabledPen ? 0.5 : 1 }}
                            >
                                {selectType === "pan_card" && loader.update ? <div className='d-flex justify-content-center align-items-center' >
                                    <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" /> </div> :
                                    <FaCloudUploadAlt
                                        style={{ fontSize: "50px", color: "#c7006d", marginBottom: "5px" }} />}
                                <span style={{ fontWeight: "500", fontSize: "16px" }}>
                                    {isUploadDisabled ? "KYC Verified." : "Choose a file or drag & drop it here"}
                                </span>

                                <input type="file" accept=".jpg, .jpeg, .png, .gif"

                                    onChange={(e) => handleFileChange(e.target.files[0], "pan_card")}
                                    disabled={isUploadDisabledPen}
                                    style={{ cursor: isUploadDisabledPen ? "not-allowed" : "pointer" }}
                                />

                            </div>
                        </div>
                        <div className='col-xl-5 col-xxl-4 col-lg-6 col-sm-12 col-md-7 m-auto mb-4'>
                            <div className='account-block my-account-block d-flex justify-content-center flex-column py-4'>

                                <div className='document-bg'> <img src={pan_cardUrl ? pan_cardUrl : Pancard} alt="" className='img-fluid' /></div>

                                {
                                    selectType === "pan_card" && loader.update ? <div className='d-flex justify-content-center align-items-center mt-2' >
                                        <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" /> we are currently fetching your details </div> :
                                        kyc && Object.keys(kyc).length > 0 ? e_pan_kyc === "0" && kyc?.is_pan_uploaded === "1" ? <div className='creator_new_task h-100 mt-4'>
                                            <div className='account-block p-3 phone-emails mb-3'>
                                                <form onSubmit={handleSubmitPanVerify}>
                                                    <div className="submission_wrap d-flex flex-column align-items-start submission_bg mt-2 mb-3"><label for="" className="form-label">Name</label><input style={{ fontSize: "14px" }} type="text" className="form-control" id="" placeholder="pan card holder number" name="name" value={pan_ocr?.name} onChange={handleChangeOcr} required /></div>
                                                    <div className="submission_wrap d-flex flex-column align-items-start submission_bg mt-2 mb-3"><label for="" className="form-label">Pan Number</label><input style={{ fontSize: "14px" }} type="text" className="form-control text-uppercase" id="" placeholder="pan number" name="Pan" value={pan_ocr?.Pan} onChange={handleChangeOcr} required /></div>
                                                    {/* <div className="submission_wrap d-flex flex-column align-items-start submission_bg mt-2 mb-3"><label for="" className="form-label">Date of birth</label><input type="date" className="form-control" id="" placeholder="date of birth" name="dateOfBirth" value={pan_ocr?.dateOfBirth} onChange={handleChangeOcr} required /></div>  */}
                                                    <div className="submission_wrap position-relative  submission_bg mt-2 mb-3">
                                                        <label for="" className="form-label text-start">Date of birth</label>
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <Calendar placeholder='Dob' className='w-100' value={pan_ocr?.dateOfBirth && new Date(pan_ocr?.dateOfBirth)} onChange={handleChangeOcr} dateFormat="yy-mm-dd" />
                                                            <FaRegCalendarAlt
                                                                style={{ fontSize: "20px", color: "#0000009c" }} />
                                                        </div>

                                                    </div>
                                                    <div className="form-check">
                                                        <input className="form-check-input custom-checks" type="checkbox" value="" id="flexCheckChecked" required />
                                                        <label className="form-check-label" for="flexCheckChecked">
                                                            <p className='text-start'>I hereby confirm that the Pan number provided by me is accurate, and I authorize DoTasks to verify my Pan details</p>
                                                        </label>
                                                    </div>
                                                    <button className='theme-btn d-flex justify-content-end ms-auto' type="submit">Verfiy Pan{loader.pan ? <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" /> : ""}</button>
                                                </form>
                                            </div>
                                        </div> : "" : ""}
                            </div>
                        </div>
                    </div>
                    <div className='row align-items-center mt-4 '>

                        <div className="col-lg-12">
                            {/* <h3 style={{ fontSize: "18px", marginBottom: "15px" }}>Aadhar card</h3> */}
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <h3 style={{ fontSize: "18px", marginBottom: "15px" }}>Aadhar card Front</h3>
                                    <div className='account-block mb-4 my-account-block d-flex justify-content-center flex-column'>
                                        <div className='document-bg'> <img src={aadhar_card_frontUrl ? aadhar_card_frontUrl : AadharFront} alt="" className='img-fluid' /></div>
                                    </div>
                                    <div className=" create_upload mt-3 mb-3"
                                        onDragOver={(e) => !isUploadDisabled && handleDragOver(e)}
                                        onDrop={(e) => handleDrop(e, "aadhar_card_front")}
                                        style={{ cursor: isUploadDisabled ? "not-allowed" : "pointer", opacity: isUploadDisabled ? 0.5 : 1 }}
                                    >
                                        {selectType === "aadhar_card_front" && loader.update ? <div className='d-flex justify-content-center align-items-center' > <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" /> </div> : <FaCloudUploadAlt
                                            style={{ fontSize: "50px", color: "#c7006d", marginBottom: "5px" }} />}
                                        <span style={{ fontWeight: "500", fontSize: "16px" }}>
                                            {isUploadDisabled ? "KYC Verified." : "Choose a file or drag & drop it here"}
                                        </span>
                                        {/* < span style={{ color: "#A9ACB4" }}>JPEG, PNG, PDG and MP4 formats, up to 50MB</span > */}
                                        <input type="file" accept=".jpg, .jpeg, .png, .gif"

                                            onChange={(e) => handleFileChange(e.target.files[0], "aadhar_card_front")}
                                            disabled={isUploadDisabled}
                                            style={{ cursor: isUploadDisabled ? "not-allowed" : "pointer" }}
                                        />

                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <h3 style={{ fontSize: "18px", marginBottom: "15px" }}>Aadhar card Back</h3>
                                    <div className='account-block my-account-block mb-4 d-flex justify-content-center flex-column py-4'>
                                        <div className='document-bg'> <img src={aadhar_card_backUrl ? aadhar_card_backUrl : AadharBack} alt="" className='img-fluid' /></div>
                                    </div>
                                    <div className=" create_upload mb-3 mb-lg-0"
                                        onDragOver={(e) => !isUploadDisabled && handleDragOver(e)}
                                        onDrop={(e) => !isUploadDisabled && handleDrop(e, "aadhar_card_back")}
                                        style={{ cursor: isUploadDisabled ? "not-allowed" : "pointer", opacity: isUploadDisabled ? 0.5 : 1 }}
                                    >
                                        {selectType === "aadhar_card_back" && loader.update ? <div className='d-flex justify-content-center align-items-center' > <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" /> </div> : <FaCloudUploadAlt
                                            style={{ fontSize: "50px", color: "#c7006d", marginBottom: "5px" }} />}
                                        <span style={{ fontWeight: "500", fontSize: "16px" }}>
                                            {isUploadDisabled ? "KYC Verified." : "Choose a file or drag & drop it here"}
                                        </span>

                                        <input type="file" accept=".jpg, .jpeg, .png, .gif"

                                            onChange={(e) => handleFileChange(e.target.files[0], "aadhar_card_back")}
                                            disabled={isUploadDisabled}
                                            style={{ cursor: isUploadDisabled ? "not-allowed" : "pointer" }}
                                        />

                                    </div>
                                </div>
                                <div className='col-lg-12'>
                                    {(selectType === "aadhar_card_front" || selectType === "aadhar_card_back") && loader.update ? <div className='d-flex justify-content-center align-items-center mt-2' > <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" />  we are currently fetching your details </div> :
                                        kyc && Object.keys(kyc).length > 0 ? e_aadhar_kyc === "0" && kyc?.is_aadhar_uploaded === "1" ?
                                            <div className='account-block phone-emails mb-3 px-0 py-1'>
                                                <div className='creator_new_task h-100'>
                                                    <div className='account-block phone-emails mb-3 px-0 py-1'>
                                                        <form onSubmit={handleInputFieldSubmit}>
                                                            <div className="submission_wrap d-flex flex-column align-items-start submission_bg mt-2 mb-3"><label for="" className="form-label">Aadhar Number</label><input type="number" className="form-control" id="" placeholder="aadhar number" name="inputAadhar" value={inputAadhar} onChange={(e) => setInputAadhar(e.target.value)} /></div>
                                                            <div className="form-check">
                                                                <input className="form-check-input custom-checks" type="checkbox" value="" id="flexCheckCheckedsec" required />
                                                                <label className="form-check-label" for="flexCheckCheckedsec">
                                                                    <p className='text-start'> I hereby confirm that the Aadhar number provided by me is accurate, and I authorize DoTasks to verify my Aadhar details</p>
                                                                </label>
                                                            </div>
                                                            <button className='theme-btn d-flex justify-content-end ms-auto' type="submit">Verify aadhar{loader.input ? <FaSpinner style={{ fontSize: "12px" }} className="spin ms-1" /> : ""}</button>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div> : "" : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <KycModel
                        show={showKyc}
                        handleClose={handleClose}
                        text={text}
                        setText={setText}
                        loader={loader}
                        handleSubmit={handleQuerySubmit}
                    />
                    {/* <CommonInputFieldKycModel show={show1} handleClose={handleClose1} loaderOtp={loader.input} handleOtpVerfiy={handleInputFieldSubmit} inputKyc={inputKyc} setInputKyc={setInputKyc} selectTypeKyc={selectTypeKyc} / > /} */}
                    <ConfirmModelOtp show={show2} handleClose={handleClose2} loaderOtp={loader.otp} handleOtpVerfiy={handleOtpFieldSubmit} OTP={otp} setOTP={setOtp} type="kyc" />
                </div >
            </div >
        </div >
    )
}

export default TaskerKyc
